import React from 'react';
import { cn } from '@/shared/lib/classnames/cn';
import { bottomBarVariants } from '../model/variants';
import type { BottomBarProps } from '../model/types';
export const BottomBar: React.FC<BottomBarProps> = ({
  children,
  variant,
  align
}) => {
  return <div className={cn(bottomBarVariants({
    variant,
    align
  }))} data-sentry-component="BottomBar" data-sentry-source-file="index.tsx">{children}</div>;
};